(function () {
  'use strict';
  var popup = document.getElementById('anom-newsletter-popup');
  if (!popup || popup.dataset.bound) return;
  popup.dataset.bound = 'true';
  var form = popup.querySelector('form');
  var status = popup.querySelector('[data-popup-status]');
  var key = 'anom-popup-choice-v1';
  var closed = false;
  var busy = false;
  var interacted = false;
  var delayElapsed = false;
  var returnFocus;
  var timer;
  function remembered() {
    try { var value = JSON.parse(localStorage.getItem(key)); return value && (value.subscribed || value.until > Date.now()); }
    catch (_) { return false; }
  }
  function remember(subscribed) {
    try { localStorage.setItem(key, JSON.stringify({subscribed:subscribed,until:Date.now()+7*86400000})); } catch (_) {}
  }
  function excluded() {
    return /\/(cart|checkout|account|challenge|checkouts)(\/|$)/.test(location.pathname) || /club-configurateur|preview_theme_id|view=/.test(location.search) || /construire|configurateur/.test(location.hash);
  }
  function competingDialog() {
    return Array.from(document.querySelectorAll('#shopify-pc__banner, dialog[open], details[open].menu-drawer-container, .menu-drawer-container[open], cart-drawer.active, [role="dialog"][aria-modal="true"]')).some(function (element) {
      var style=getComputedStyle(element);var rect=element.getBoundingClientRect();
      return style.visibility==='visible' && style.display!=='none' && Number(style.opacity)>0 && rect.width>0 && rect.height>0 && rect.left<innerWidth && rect.right>0 && rect.top<innerHeight && rect.bottom>0;
    });
  }
  function show() {
    if (closed || remembered() || excluded() || !interacted || !delayElapsed || document.visibilityState !== 'visible' || competingDialog()) return;
    if (/^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName || '')) return;
    if (popup.hidden) returnFocus=document.activeElement;
    popup.hidden = false;
  }
  function close() {
    closed = true; popup.hidden = true; remember(!!popup.querySelector('[data-popup-success]'));
    clearTimeout(timer);
    if (popup.contains(document.activeElement)) {
      document.activeElement.blur();
      if (returnFocus && returnFocus.isConnected) returnFocus.focus({preventScroll:true});
    }
  }
  popup.querySelectorAll('[data-popup-close]').forEach(function (button) { button.addEventListener('click',close); });
  popup.addEventListener('focusin',function () { if (!returnFocus && document.activeElement && !popup.contains(document.activeElement)) returnFocus=document.activeElement; });
  document.addEventListener('keydown',function (event) { if (event.key==='Escape' && !popup.hidden) close(); });
  addEventListener('hashchange',function () { if (excluded()) { popup.hidden=true; closed=true; } });
  // No backdrop, body lock, touch interception or global overflow changes.
  ['scroll','pointerdown','keydown'].forEach(function (name) {
    addEventListener(name,function () { interacted=true; show(); },{passive:true});
  });
  timer=setTimeout(function () { delayElapsed=true; show(); },20000);
  if (popup.querySelector('[data-popup-success]')) { remember(true); popup.hidden=false; }
  else if (popup.querySelector('[data-popup-errors]')) { popup.hidden=false; }
  form.addEventListener('submit',async function (event) {
    event.preventDefault();event.stopImmediatePropagation();
    if (busy || !form.reportValidity()) return;
    var button=form.querySelector('button[type="submit"]');
    var field=form.querySelector('input[type="email"]');
    busy=true;button.disabled=true;field.readOnly=true;status.textContent='Inscription en cours…';
    var timeout;
    try {
      await new Promise(function (resolve,reject) {
        var settled=false;var poll;
        function finish(error) { if (settled) return;settled=true;clearTimeout(timeout);clearTimeout(poll);error?reject(error):resolve(); }
        timeout=setTimeout(function () { finish(new Error('captcha_timeout')); },15000);
        function protect() {
          if (settled) return;
          if (!window.Shopify?.captcha?.protect) { poll=setTimeout(protect,50);return; }
          try { window.Shopify.captcha.protect(form,function () { finish(form.submit!==HTMLFormElement.prototype.submit?null:new Error('captcha_not_ready')); }); }
          catch(error) { finish(error); }
        }
        protect();
      });
      status.textContent='Finalisation sécurisée de votre inscription…';
      await form.submit();
      // Only remember success after Shopify confirms it, not after a request intent.
    } catch (_) { status.textContent='L’inscription n’a pas abouti. Réessayez dans un instant.';busy=false;button.disabled=false;field.readOnly=false; }
  },true);
}());
